/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { LoadingDots } from '@vaas/react-ui-kit';

import { cn } from '@/lib/cn';
import './loading.css';

/*
 * The dots are the kit's (`size` in px, decorative unless given a `label`; the pulse holds still
 * for reduced motion). Re-exported so the existing `@/components/loading/LoadingDots` imports stay
 * put.
 */
export { LoadingDots, type LoadingDotsProps } from '@vaas/react-ui-kit';

/**
 * Dots plus their label, for the common "…is loading" line.
 *
 * Kept local rather than using the kit's `InlineLoading`, which renders a `<div>`: this one is a
 * `<span>`, so it stays valid inside the `<p>` hint lines that most call sites put it in.
 */
export function InlineLoading({ label, className }: { label: string; className?: string }) {
  return (
    <span className={cn('ld-inline', className)} role="status">
      <LoadingDots />
      {label}
    </span>
  );
}
